<template>
  <b-dropdown
    scrollable
    :max-height="maxHeight"
    position="is-bottom-left"
    append-to-body
    aria-role="list"
  >
    <a slot="trigger" role="button" @click="consultNotifications">
      <b-icon v-if="active" icon="bell" type="is-warning"></b-icon>
      <b-icon v-else icon="bell-outline"></b-icon>
    </a>

    <b-dropdown-item
      v-for="notification in getNotifications"
      :key="notification.id"
      value="profile"
      has-link
      aria-role="listitem"
    >
      <component
        @click="console.log('helo')"
        :is="craftNotificationComponent(notification.attributes.notifiable.data.type)"
        :content="notification"
      />
    </b-dropdown-item>

    <b-dropdown-item value="profile" has-link aria-role="listitem">
      <div class="has-text-centered">
        <span v-if="!remainingNotifications" class="is-italic has-text-gray">There is no older notification</span>
        <a v-else @click.stop="loadMoreComments" class="has-text-primary">Load More</a>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { mapGetters } from 'vuex'
import Comment from './notifications/Comment'
export default {
  props: ['active'],
  computed: {
    ...mapGetters('notifications', [
      'getNotifications',
      'remainingNotifications',
      'loadedPages'
    ])
  },
  components: {
    commentNotification: Comment
  },
  data () {
    return {
      maxHeight: 500
    }
  },
  methods: {
    consultNotifications () {
      this.$emit('consult')
    },
    loadMoreComments () {
      this.$store.dispatch('notifications/index', this.loadedPages + 1)
    },
    craftNotificationComponent (name) {
      return `${name}Notification`
    }
  }
}
</script>
